
import Vue from 'vue';
import { Team, TeamMember } from '@run-diffusion/shared';
import { ROUTER } from '@/router/constants';
import { formatTruncatedEmailForChip } from '@/utils/utils';

export default Vue.extend({
	name: 'TeamMemberChip',
	props: {
		teamMember: {
			type: Object as () => TeamMember,
			required: true,
		},
		currTeam: {
			type: Object as () => Team,
			required: true,
		},
	},
	methods: {
		formatTruncatedEmailForChip,
		onViewTeamMember() {
			if (!this.teamMember.isAccepted) return;
			this.routerPush(this.$route, this.$router, {
				name: ROUTER.TEAM_MEMBER_DASHBOARD,
				params: {
					teamId: this.currTeam.id,
					teamMemberId: this.teamMember.id,
				},
				query: this.$route.query,
			});
		},
	},
});
